import React from 'react';

// Styles & Assets
import styles from './InquirySlot.module.css';

// Utils
import { dateFormat } from '../../../services/parseDates';

// Hooks
import { useTranslation } from 'react-i18next';

// Models
interface Props {
    label: React.ReactNode
    date: string
    isAnswered: boolean
    disabled: boolean
    onClick: () => void
}

const InquirySlot: React.FC<Props> = ({ label, date, isAnswered, disabled, onClick }) => {

    const { t } = useTranslation();

    return (
        <div className={styles.inquirySlot}>
            <div className={styles.inquirySlotData}>
                <div className={styles.titleInquiry}>
                    {label}
                </div>
                <p className={styles.titleDate}>
                    {t('assigned_on')} {dateFormat(date)}
                </p>
            </div>
            <button
                disabled={disabled}
                onClick={onClick}
                className={`button ${styles.inquirySlotButton} ${isAnswered ?
                    styles.resultsButton : styles.answersButton}`}
            >
                {isAnswered ? t('results') : t('answer')}
            </button>
        </div>
    );
};

export default InquirySlot;